module.exports = __webpack_public_path__ + "img/Logo@3x.9e38b8cb.svg";